
import * as handlebars_family from "../handlebars_family.js";
import "../list/tasklist_head.mustache";
import "../list/task_quickadd.mustache";
import "../list/tasksortby.mustache";
import "../list/task-container-content.mustache";
const TPL = handlebars_family.addTemplate("list/tasklist",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<flexcol class=\"V4 fw-todoPanel\" data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" style=\"--list-color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + "\"> "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"list/tasklist_head"),depth0,{"name":"list/tasklist_head","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " <div style=\"padding:0 var(--space);\"> "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"list/task_quickadd"),depth0,{"name":"list/task_quickadd","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " </div><div class=\"fw-sorting-tasks\"> "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"list/tasksortby"),depth0,{"name":"list/tasksortby","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " </div><flexauto id=\"task-container\" style=\"font-size:16px;padding:var(--space)\"> "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"list/task-container-content"),depth0,{"name":"list/task-container-content","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " </flexauto></flexcol> ";
},"usePartial":true,"useData":true});
export default TPL;